import { render, staticRenderFns } from "./SubmissionHistory.vue?vue&type=template&id=b7bdc994&scoped=true&"
import script from "./SubmissionHistory.vue?vue&type=script&lang=js&"
export * from "./SubmissionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionHistory.vue?vue&type=style&index=0&id=b7bdc994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bdc994",
  null
  
)

export default component.exports